/**
 * Frontend role-gate helper — the client-side half of R2's `admin` wildcard.
 *
 * Mirrors `satisfiesRole`'s wildcard semantics from `src/auth/roles.ts`
 * (server-side source of truth): holding the `'admin'` role satisfies any
 * gate, with no separate grant required. `anyOf: []` means "admin only" —
 * there is no narrower slug to match, so only the wildcard can pass.
 */
export function hasRequiredRole(roles: string[] | undefined, anyOf: string[]): boolean {
  const granted = roles ?? [];
  if (granted.includes('admin')) return true;
  return anyOf.some((slug) => granted.includes(slug));
}
